import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ActivityEffects } from 'app/state/activities/activity.effects';

import { activityFeature } from './activity.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(activityFeature), EffectsModule.forFeature([ActivityEffects])],
})
export class ActivityStateModule {}
